<!-- style="background-image: url('https://images.xceed.me/static/b2cweb/home/xceed-events-clubs-djs-11.jpg?h=722&fm=auto');" -->

<div class="img-banner d-flex justify-content-center  align-items-center row no-margin">
  <!-- <div style=" margin-top: 30vh;" class="col-12 text-center d-flex justify-content-center row">
  <h1 class="text-banner col-12 ">VIVE LA EXPERIENCIA</h1>
  <p class="col-8 p-banner d-flex justify-content-center  align-items-center mt-3">
    <mat-icon style="margin-right: 10px;" matSuffix>search</mat-icon> Haz click aqui para buscar eventos
    futuros.
  </p>

</div> -->

  <div class="col-12 row d-flex justify-content-center mb-5 text-center" style="margin-top: 100px;">

    <h1 style="color:black"> Servicios On Ticket Chile</h1>

    <div class="col-md-3 mt-2 mb-2 ">
      <div class="col-12  d-flex justify-content-center  align-items-center div-home-card-admin-dash"
        style="background-image: url('../../../assets/imgs/izidrink-home-bar-banner.jpg');">
        <mat-card class="col-11 mat-card-transparent">
          <mat-card-title-group class=" d-flex   align-items-center">
            <mat-card-title>Crear de Eventos </mat-card-title>
            <mat-card-subtitle style="margin-bottom: 0px;">organiza tu evento</mat-card-subtitle>
            <mat-icon matSuffix>celebration</mat-icon>

          </mat-card-title-group>
          <mat-card-content>

          </mat-card-content>
          <mat-card-actions class="d-flex justify-content-center">
            <button class="col-12" mat-button>IR</button>
          </mat-card-actions>
        </mat-card>

      </div>
    </div>


    <div class="col-md-3 mt-2 mb-2 ">
      <div class="col-12  d-flex justify-content-center  align-items-center div-home-card-admin-dash"
        style="background-image: url('../../../assets/imgs/izidrink-home-bar-banner.jpg');">
        <mat-card class="col-11 mat-card-transparent">
          <mat-card-title-group class=" d-flex   align-items-center">
            <mat-card-title>Crear Carta </mat-card-title>
            <mat-card-subtitle style="margin-bottom: 0px;">Creación de carta de consumo</mat-card-subtitle>
            <mat-icon matSuffix>menu_book</mat-icon>

          </mat-card-title-group>
          <mat-card-content>

          </mat-card-content>
          <mat-card-actions class="d-flex justify-content-center">
            <button class="col-12" mat-button>IR</button>
          </mat-card-actions>
        </mat-card>

      </div>
    </div>



    <div class="col-md-3 mt-2 mb-2 ">
      <div class="col-12  d-flex justify-content-center  align-items-center div-home-card-admin-dash"
        style="background-image: url('../../../assets/imgs/izidrink-home-bar-banner.jpg');">
        <mat-card class="col-11 mat-card-transparent">
          <mat-card-title-group class=" d-flex   align-items-center">
            <mat-card-title> Control Ticket Qr</mat-card-title>
            <mat-card-subtitle style="margin-bottom: 0px;">Control de ticket de Acceso y Menu</mat-card-subtitle>
            <mat-icon matSuffix>barcode_reader</mat-icon>

          </mat-card-title-group>
          <mat-card-content>

          </mat-card-content>
          <mat-card-actions class="d-flex justify-content-center">
            <button class="col-12" mat-button>IR</button>
          </mat-card-actions>
        </mat-card>

      </div>
    </div>



    <div class="col-md-3 mt-2 mb-2 ">
      <div class="col-12  d-flex justify-content-center  align-items-center div-home-card-admin-dash"
        style="background-image: url('../../../assets/imgs/izidrink-home-bar-banner.jpg');">
        <mat-card class="col-11 mat-card-transparent">
          <mat-card-title-group class=" d-flex   align-items-center">
            <mat-card-title> Sistema Boleteria </mat-card-title>
            <mat-card-subtitle style="margin-bottom: 0px;">Venta de entradas para evento</mat-card-subtitle>
            <mat-icon matSuffix>point_of_sale </mat-icon>

          </mat-card-title-group>
          <mat-card-content>

          </mat-card-content>
          <mat-card-actions class="d-flex justify-content-center">
            <button class="col-12" mat-button>IR</button>
          </mat-card-actions>
        </mat-card>

      </div>
    </div>


  </div>

  <!-- <div
    class=" animate__animated animate__bounce animate__infinite	infinite  col-12 text-center d-flex justify-content-center row">
    <mat-icon style="font-size: 70px; color: white;height: 100%;
    width: 100%;" matSuffix>expand_more</mat-icon>
  </div> -->

</div>